import { render, staticRenderFns } from "./eliminar_editoriales.vue?vue&type=template&id=d10fea4c"
import script from "./eliminar_editoriales.vue?vue&type=script&lang=js"
export * from "./eliminar_editoriales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports